document.addEventListener('alpine:init', () => {
  Alpine.store('kitBuilder', {
    initialProductsArray: [], // Contains all the product's data in the BYK page
    unselectedProductsArray: [], // Contains all the product's data that aren't selected
    selectedProductsArray: [], // Contains all the selected products; this is the final payload that would be pass to CartJS.addItems function
    kitFreeProduct: {}, // Contains the free product included in the kit
    kitSelectedVariantsArray: [], // Contains all selected variants in a specific product (i.e Recoloring Balm - Brown, Black, Beige, etc)
    selectedProductsInCartArray: [], // Contains all the products that are already added in cart
    kitSelectedVariantsState: false, // Check if product with variants is finalize (Added to selectedProductsArray and no pending action)
    quantitySetLimit: {  // Set the minimum & maximum quantity required per each product item
      min: 0,
      max: 0
    },
    selectedProductTotalPrice: {  // Holds total kit products prices and discounts (Used in BYK page only)
      original_value: 0,
      discounted_value: 0,
      formatted_original_value: "",
      formatted_discounted_value: ""
    },
    selectedProductTotalDiscounts: { // Holds total kit products discount prices (Used in BYK page only)
      final_value: 0,
      formatted_final_value: ""
    },
    cartFinalTotalPrice: 0,  // Holds total kit products price (discounts applied)
    cartTotalDiscountPrice: 0, // Holds total kit products discount prices; Used in Cart offCanvas
    cartOriginalTotalPrice: 0, // Holds total kit products prices; Used in Cart offCanvas
    cartTotalRegularProducts: 0, // Holds the total number of regular items in cart
    cartTotalBalmProducts: 0, // Holds the total number of regular items in cart
    cartTotalProducts: 0, // Holds the total number of products in cart (includes the Kit products)
    showUpsell: true,

    init() {
      this.setProductsDataInCart()
      this.setUpsellVisibility()
    },

    setProductsDataInCart() {
      async function fetchCartItems() {
        try {
          const response = await fetch('/cart.js', { cache: 'no-store' })
          if (!response.ok) { throw new Error('Failed response') }

          const cart = await response.json()

          // if (!cart.items || cart.items.length === 0) {
          //   return await fetchCartItems()
          // }

          const getTotalProductsLength = cart.items.filter(item => !(window.ckSP && window.ckSP.isProtection && window.ckSP.isProtection(item)))
          const getRegularProducts = cart.items.filter(item => item.properties._added_by_byk != 'build-your-kit' && !(window.ckSP && window.ckSP.isProtection && window.ckSP.isProtection(item)))
          const getBalmProducts = cart.items.filter(item => {
            if(item.properties._nice_title) {
              return item.properties._nice_title.toLowerCase().includes("balm")
            }

            return false;
          });

          Alpine.store('kitBuilder').cartTotalProducts = getTotalProductsLength
          Alpine.store('kitBuilder').cartTotalRegularProducts = getRegularProducts.length
          Alpine.store('kitBuilder').cartTotalBalmProducts = getBalmProducts.length

          return cart
        } catch (error) {
          console.error('Fetch error:', error)
        }
      }

      fetchCartItems()
    },

    setUpsellVisibility() {
      if(window.location.href.indexOf(window.excludedPagesForUpsell) < 0) return;
      this.showUpsell = false
    },

    addFreeGiftToKit() {
      if(!this.kitFreeProduct) return;
      const hasFreeGift = this.selectedProductsArray.findIndex(item =>
        item.id === this.kitFreeProduct.id) > -1;

      if (hasFreeGift) return
      // if (Object.keys(this.kitFreeProduct).length <= 0) return
      this.selectedProductsArray.push(this.kitFreeProduct)
    },

    addProductToKit(product) {
      const duplicateProductItem = this.selectedProductsArray.findIndex(item => item.id === product.id)
      if (duplicateProductItem !== -1) {
        this.selectedProductsArray.splice(duplicateProductItem, 1)
      }

      this.selectedProductsArray.push(product)

      this.calculateTotalDiscountedPrice()
      this.calculateTotalPrice()
      this.setUnselectedProducts()
    },

    removeProductToKit(productId) {
      const duplicateProductItem = this.selectedProductsArray.findIndex(item => item.id === productId)
      if (duplicateProductItem) {
        this.selectedProductsArray.splice(duplicateProductItem, 1)
      }

      this.calculateTotalDiscountedPrice()
      this.calculateTotalPrice()
      this.setUnselectedProducts()
    },

    updateProductQuantityInKit(id, quantity, inCart) {
      const getProductItem = this.selectedProductsArray.find(item => item.id === id)

      if (!getProductItem) return

      getProductItem.quantity = quantity

      this.calculateTotalDiscountedPrice()
      this.calculateTotalPrice()
      this.setUnselectedProducts()
    },

    calculateTotalDiscountedPrice() {
      if (!this.selectedProductsArray) return

      let totalDiscountedPrice = 0

      this.selectedProductsArray.map(product => {
        let getCurrrentDiscount

        if (product.quantity > this.quantitySetLimit.min) {
          getCurrrentDiscount = product.discount_options[product.discount_options.length - 1]
          totalDiscountedPrice += (product.price * getCurrrentDiscount.discount_value) * product.quantity
        } else {
          getCurrrentDiscount = product.discount_options.filter(option => option.quantity_value === product.quantity)
          totalDiscountedPrice += (product.price * getCurrrentDiscount[0].discount_value) * product.quantity
        }
      })

      this.selectedProductTotalDiscounts.final_value = totalDiscountedPrice
      this.selectedProductTotalDiscounts.formatted_final_value = this.formatPrices(totalDiscountedPrice)
    },

    calculateTotalPrice() {
      if (!this.selectedProductsArray) return

      let totalPrice = 0
      this.selectedProductsArray.map(product => totalPrice += (product.price * product.quantity))

      this.selectedProductTotalPrice.original_value = totalPrice
      this.selectedProductTotalPrice.discounted_value = totalPrice - this.selectedProductTotalDiscounts.final_value

      this.selectedProductTotalPrice.formatted_original_value = this.formatPrices(totalPrice)
      this.selectedProductTotalPrice.formatted_discounted_value = this.formatPrices(this.selectedProductTotalPrice.discounted_value)
    },

    calculateTotalPriceInCart(productArray) {
      if (!productArray) return

      let totalPrice = 0, totalDiscount = 0

      productArray.forEach(product => {
        totalPrice += product.final_line_price
        totalDiscount += product.total_discount
      })

      this.cartFinalTotalPrice = this.formatPrices(totalPrice)
      this.cartTotalDiscountPrice = this.formatPrices(totalDiscount)
      this.cartOriginalTotalPrice = this.formatPrices(totalPrice + totalDiscount)
    },

    formatPrices(price) {
      return Alpine.store('methods').formatMoney(price)
    },

    flattenSelectedProductsArray() {
      this.selectedProductsArray = this.selectedProductsArray.flat(Infinity)
    },

    setInitialProducts() {
      this.initialProductsArray = window.MFR_BYK_PRODUCTS
      this.kitFreeProduct = window.MFR_BYK_FREE_PRODUCT
    },

    setUnselectedProducts() {
      const unmatchedItems = this.initialProductsArray.filter(item => !this.selectedProductsArray.some(selected => selected.title == item.title))
      this.unselectedProductsArray = unmatchedItems
    },

    setCartData() {
      async function fetchCartItems() {
        try {
          const response = await fetch('/cart.js', { cache: 'no-store' })
          if (!response.ok) { throw new Error('Failed response') }

          const cart = await response.json()

          if (!cart.items || cart.items.length === 0) {
            return await fetchCartItems()
          }

          const getBYKProducts = cart.items.filter(item => item.properties._added_by_byk === 'build-your-kit')
          Alpine.store('kitBuilder').selectedProductsInCartArray = getBYKProducts
          Alpine.store('kitBuilder').calculateTotalPriceInCart(Alpine.store('kitBuilder').selectedProductsInCartArray)

          return cart
        } catch (error) {
          console.log("error")
          console.error('Fetch error:', error)
        }
      }

      fetchCartItems()
    },

    addKitToCart(element) {
      const obj = this;
      if (!this.selectedProductsArray) return
      this.addFreeGiftToKit()
      this.flattenSelectedProductsArray()

      CartJS.addItems(this.selectedProductsArray, {
        success: function() {
          obj.setCartData()
        }
      })
    }
  })

  Alpine.data('ProductItem', () => ({
    openQtyInput: false,
    quantity: 1,
    quantityLimit: 0,
    quantitySelected: 0,
    quantityRemaining: 1,
    currentSelectedVariantQuantity: 0,
    variantOptionsIsAddedState: false,
    variantOptionsState: false,
    variantOptionContainer: "",
    selectedVariantArray: [],
    dynamicImageContainer: "",
    discountLabel: "",

    init() {
      this.ProductItemSetVariantOptionsState()
      this.quantityLimit = this.quantity
      this.quantitySelected = this.quantity
      this.quantityRemaining = this.quantity

      Alpine.store('kitBuilder').quantitySetLimit.min = 4
      Alpine.store('kitBuilder').quantitySetLimit.max = 10
    },

    productItemSetQuantityLimit(element, withVariants) {
      const data = JSON.parse(element.parentNode.querySelector('.data').innerHTML)
      const { id, title, price, discount_options, image_src, image_shadow } = data
      const quantity = Number(element.dataset.quantity)

      this.quantityLimit = quantity
      this.quantitySelected = quantity
      this.quantityRemaining = quantity
      this.discountLabel = element.dataset.discountMessage;
      this.variantOptionsIsAddedState = false

      if (withVariants) {
        this.ProductItemResetAll()
        this.ProductItemSetVariantOptionsState()
      }

      if (element.classList.contains('prompt-qty-input')) {
        this.openQtyInput = true
        this.quantity = this.quantityLimit
      } else {
        this.openQtyInput = false
      }

      Alpine.store('methods').getSiblings(element).forEach(sibling => sibling.classList.remove('is-selected'))
      element.classList.add('is-selected')

      if (!withVariants) {
        Alpine.store('kitBuilder').addProductToKit({
          id: id,
          title: title,
          price: price,
          quantity: quantity,
          discount_options: discount_options,
          properties: {
            _nice_title: title,
            _added_by_byk: 'build-your-kit',
            Added_by: 'Kit Builder',
            _removeable: false
          },
          images: {
            _nice_image: image_src,
            _nice_image_shadow: image_shadow
          }
        })
      }
    },

    ProductItemIncreaseQuantity(element) {
      if (this.quantity < Alpine.store('kitBuilder').quantitySetLimit.max) {
        this.quantity++
        this.quantityLimit = this.quantity
        this.quantitySelected = this.quantity
        this.quantityRemaining = this.quantity
        Alpine.store('kitBuilder').updateProductQuantityInKit(Number(element.dataset.id), this.quantity, false)
      }
    },

    ProductItemDecreaseQuantity(element) {
      if (this.quantity > Alpine.store('kitBuilder').quantitySetLimit.min) {
        this.quantity--
        this.quantityLimit = this.quantity
        this.quantitySelected = this.quantity
        this.quantityRemaining = this.quantity
        Alpine.store('kitBuilder').updateProductQuantityInKit(Number(element.dataset.id), this.quantity, false)
      }
    },

    ProductItemSetVariantOptionsState() {
      this.quantityRemaining === 0 ? this.variantOptionsState = true : this.variantOptionsState = false
    },

    ProductItemResetSelectedVariants() {
      let activeVariantOptions = Array.from(this.variantOptionContainer.children).filter(option => option.querySelector('.multi-select-option').dataset.counter >= 1)

      if (activeVariantOptions.length === 0) return

      activeVariantOptions.forEach(activeOption => {
        activeOption.querySelector('.multi-select-option').setAttribute('data-counter', 0)
        activeOption.querySelector('.multi-select-option').classList.remove('is-selected')
      })
    },

    ProductItemResetAll() {
      Alpine.store('kitBuilder').kitSelectedVariantsArray = []
      this.currentSelectedVariantQuantity = 0
      this.variantOptionsState = false
      this.selectedVariantArray = []
      this.ProductItemResetSelectedVariants()
    },

    ProductItemAddVariant(product) {
      const duplicateProductItem = this.selectedVariantArray.findIndex(item => item.id === product.id)
      if (duplicateProductItem !== -1) {
        this.selectedVariantArray.splice(duplicateProductItem, 1)
      }

      this.selectedVariantArray.push(product)
    },

    ProductItemRemoveVariant(productId) {
      const getProductItem = this.selectedVariantArray.findIndex(item => item.id === productId)

      if (getProductItem) {
        this.selectedVariantArray.splice(getProductItem, 1)
      }
    },

    ProductItemAddSelectedVariantsToKit(element) {
      element.setAttribute('disabled', 'disabled')
      this.variantOptionsIsAddedState = true

      Alpine.store('kitBuilder').kitSelectedVariantsArray.push(this.selectedVariantArray)
      Alpine.store('kitBuilder').selectedProductsArray.push(this.selectedVariantArray)

      Alpine.store('kitBuilder').flattenSelectedProductsArray()
      Alpine.store('kitBuilder').kitSelectedVariantsState = true

      Alpine.store('kitBuilder').calculateTotalDiscountedPrice()
      Alpine.store('kitBuilder').calculateTotalPrice()
      Alpine.store('kitBuilder').setUnselectedProducts()
    },

    ProductItemResetSelectedVariantsToKit(element) {
      this.ProductItemResetAll()
      this.quantityRemaining = this.quantitySelected
      this.variantOptionsIsAddedState = false

      Alpine.store('kitBuilder').flattenSelectedProductsArray()

      const parentId = Number(element.dataset.parent)
      const removeAllSelectedVariantFromKit = Alpine.store('kitBuilder').selectedProductsArray.filter(product => product.parent !== parentId)

      Alpine.store('kitBuilder').selectedProductsArray = removeAllSelectedVariantFromKit

      Alpine.store('kitBuilder').calculateTotalDiscountedPrice()
      Alpine.store('kitBuilder').calculateTotalPrice()
      Alpine.store('kitBuilder').setUnselectedProducts()
    }
  }))

  Alpine.data('BYKVariantOption', () => ({
    setVariantQuantity: 0,

    addVariantIntoSelection(element, data) {
      let counter = Number(element.dataset.counter)

      const variantData = JSON.parse(element.parentNode.querySelector('.variant-data').innerHTML)
      const { id, title, option, hue, price, parent, featured_image, image_application_src, discount_options } = variantData

      const matchItem = Alpine.store('kitBuilder').initialProductsArray.filter(item => item.parent === parent)

      if (data.currentSelectedVariantQuantity < data.quantitySelected) {
        counter++
        this.setVariantQuantity = counter
        element.setAttribute('data-counter', counter)
        element.classList.add('is-selected')

        if (this.setVariantQuantity > 1) {
          data.currentSelectedVariantQuantity = data.currentSelectedVariantQuantity + 1
        } else {
          data.currentSelectedVariantQuantity = data.currentSelectedVariantQuantity + this.setVariantQuantity
        }

        // this.changeVariantApplicationImage(title, option, image_application_src, data)
        this.changeVariantApplicationImageToVariantFeaturedImage(title, option, featured_image, data)

        data.quantityRemaining = data.quantitySelected - data.currentSelectedVariantQuantity
        data.ProductItemAddVariant({
          id: id,
          option: option,
          option_hue: hue,
          price: price,
          quantity: counter,
          parent: parent,
          title: matchItem[0].title,
          handle: matchItem[0].handle,
          discount_options: discount_options,
          images: {
            image: matchItem[0].images.image,
            shadow: matchItem[0].images.shadow
          },
          properties: {
            _nice_title: `${matchItem[0].title} - ${option}`,
            _added_by_byk: 'build-your-kit',
            _removeable: false,
            Added_by: 'Kit Builder'
          },
        })
      }

      data.ProductItemSetVariantOptionsState()
    },

    removeVariantIntoSelection(element, data) {
      element.previousElementSibling.classList.remove('is-selected')
      element.previousElementSibling.setAttribute('data-counter', 0)

      data.currentSelectedVariantQuantity = data.currentSelectedVariantQuantity - this.setVariantQuantity
      data.quantityRemaining = data.quantitySelected - data.currentSelectedVariantQuantity

      data.ProductItemRemoveVariant(Number(element.previousElementSibling.dataset.id))
      data.ProductItemSetVariantOptionsState()
      data.variantOptionsIsAddedState = false

      Alpine.store('kitBuilder').kitSelectedVariantsArray = []
      Alpine.store('kitBuilder').kitSelectedVariantsState = false
    },

    changeVariantApplicationImage(productTitle, variantName, featuredImage, data) {
      data.dynamicImageContainer.innerHTML = `<img src="${featuredImage}" alt="${productTitle} - ${variantName}" class="image-cover">`
    },

    changeVariantApplicationImageToVariantFeaturedImage(productTitle, variantName, featuredImage, data) {
      data.dynamicImageContainer.classList.add('dynamic-variant-image')
      data.dynamicImageContainer.innerHTML = `<img src="${featuredImage}" alt="${productTitle} - ${variantName}" class="image-cover fade-out">`

      setTimeout(() => {
        data.dynamicImageContainer.querySelector('img').classList.remove('fade-out')
      }, 250)
    }
  }))

  Alpine.data('OrderSummary', () => ({
    init() {
      Alpine.store('kitBuilder').calculateTotalDiscountedPrice()
      Alpine.store('kitBuilder').calculateTotalPrice()
      Alpine.store('kitBuilder').setInitialProducts()
      Alpine.store('kitBuilder').setUnselectedProducts()
    }
  }))

  Alpine.data('KitItemsInCart', () => ({
    init() {
      this.getKitItemsInCart()
    },

    updateProductQuantityInCart(id, quantity) {
      CartJS.updateItemById(id, quantity).then(response => {
        if (!response) return

        const getProductItem = Alpine.store('kitBuilder').selectedProductsInCartArray.find(item => item.id === id)
        if (!getProductItem) return

        getProductItem.quantity = quantity

        Alpine.store('kitBuilder').setCartData()
      })
    },

    increaseProductQuantityInCart(id, quantity) {
      let newQuantity = quantity + 1
      this.updateProductQuantityInCart(id, newQuantity)
    },

    decreaseProductQuantityInCart(id, quantity) {
      let newQuantity = quantity

      if (quantity > 1) {
        newQuantity = quantity - 1
      } else if (quantity === 1) {
        newQuantity = 0
      }

      this.updateProductQuantityInCart(id, newQuantity)
    },

    removeKitProducts() {
      const productsToRemove = {};
      const getBYKProducts = CartJS.cart.items.filter(item => item.properties._added_by_byk === 'build-your-kit')

      getBYKProducts.forEach(product =>
        {
          productsToRemove[product.variant_id] = 0;
        }
      );

      document.getElementsByClassName("offcanvas-cart__form")[0].classList.add("loading");

      CartJS.updateItemQuantitiesById(productsToRemove, {
        success: function() {
          document.getElementsByClassName("offcanvas-cart__form")[0].classList.remove("loading");
        }
      });

      Alpine.store('kitBuilder').selectedProductsInCartArray = []
    },

    getKitItemsInCart() {
      async function fetchCartItems() {
        try {
          const response = await fetch('/cart.js', { cache: 'no-store' })
          if (!response.ok) { throw new Error('Failed response') }

          const cart = await response.json()
          const getBYKProducts = cart.items.filter(item => item.properties._added_by_byk === 'build-your-kit')
          Alpine.store('kitBuilder').selectedProductsInCartArray = getBYKProducts
          Alpine.store('kitBuilder').calculateTotalPriceInCart(Alpine.store('kitBuilder').selectedProductsInCartArray)

          return cart
        } catch (error) {
          console.error('Fetch error:', error)
        }
      }

      fetchCartItems()
    }
  }))
})